import {
  NotificationsActiveRounded,
  Notifications as NotificationsIcon,
  NotificationsRounded,
} from '@mui/icons-material';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { useNotificaciones } from '../hooks/useNotificaciones';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

export const CampanaNotificaciones = () => {
  var { notificacionesCount } = useNotificaciones();

  return (
    <Tooltip title='Notificaciones'>
      <IconButton
        size='large'
        edge='end'
        aria-label='Menú de notificaciones.'
        sx={{ ml: { xs: 0, md: 2 } }}
        color='inherit'
        component={NavLink}
        to={'notificaciones'}
        exact
      >
        <Badge color='error' badgeContent={notificacionesCount}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};
